module.exports = require('./lib');


//////////////////
// WEBPACK FOOTER
// ../~/react-cookie-banner/index.js
// module id = 684
// module chunks = 0